import script from "./AddData.vue?vue&type=script&setup=true&lang=js"
export * from "./AddData.vue?vue&type=script&setup=true&lang=js"

import "./AddData.vue?vue&type=style&index=0&id=2072c820&lang=scss"

const __exports__ = script;

export default __exports__